
const digest = '47dde825c731de7e4125f5a0526eb277205c1c29f2b7eb69f9b663c2843f2433';
const css = `._timeline_1t6rm_1 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 2em 0 4em;
  width: 100%;
}

._tooltip_1t6rm_10 {
  --background-color: white;
  --corner-size: 30px;
  --font-color: #ddd;

  background-color: var(--secondary-color);
  color: var(--font-color);
  line-height: 1.4;
  margin: 0em auto 2em;
  position: relative;
  width: 60%;
}

@media screen and (max-width: 1200px) {
  ._tooltip_1t6rm_10 {
    width: 80%;
  }
}

@media screen and (max-width: 1000px) {
  ._tooltip_1t6rm_10 {
    width: 85%;
  }
}

@media screen and (max-width: 800px) {
  ._tooltip_1t6rm_10 {
    width: 90%;
  }
}

._toolbody_1t6rm_41 {
  max-height: 60vh;
  overflow-y: auto;
  padding: 1em 2em;
}

._tooltip_1t6rm_10::before,
._tooltip_1t6rm_10::after,
._toolbody_1t6rm_41::before,
._toolbody_1t6rm_41::after {
  content: "";
  position: absolute;
  border-style: solid;
}

._tooltip_1t6rm_10::before {
  top: 0;
  left: 0;
  border-width: var(--corner-size) var(--corner-size) 0 0;
  border-color: var(--background-color) transparent transparent var(--background-color);
}

._tooltip_1t6rm_10::after {
  top: 0;
  right: 0;
  border-width: var(--corner-size) 0 0 var(--corner-size);
  border-color: var(--background-color) var(--background-color) transparent transparent;
}

._toolbody_1t6rm_41::before {
  bottom: 0;
  left: 0;
  border-width: 0 var(--corner-size) var(--corner-size) 0;
  border-color: transparent transparent var(--background-color) var(--background-color);
}

._toolbody_1t6rm_41::after {
  bottom: 0;
  right: 0;
  border-width: 0 0 var(--corner-size) var(--corner-size);
  border-color: transparent var(--background-color) var(--background-color) transparent;
}

._toolbody_1t6rm_41 {
  overflow-y: scroll;
}

._tooltip_1t6rm_10 h2 {
  color: var(--background-color);
  border-bottom: solid 1px currentColor;
}

._tooltip_1t6rm_10 h2 small {
  float: right;
}

._tooltip_1t6rm_10 h4 {
  border-bottom: solid 1px currentColor;
}

._tooltip_1t6rm_10 a {
  color: currentColor;
}

._tooltip_1t6rm_10 li + li {
  margin-top: 0.75em;
}

._tooltip_1t6rm_10 code {
  color: var(--ternary-color);
  font-size: 1.2em;
  padding: 0 3px;
}

._tooltip_1t6rm_10 br + code,
._tooltip_1t6rm_10 code:first-child {
  padding-left: 0;
}

._marker_1t6rm_120 {
  position: absolute;
  bottom: -3px;
  height: 1.5em;
  left: -0.75em;
  width: 1.5em;
}
`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"timeline":"_timeline_1t6rm_1","tooltip":"_tooltip_1t6rm_10","toolbody":"_toolbody_1t6rm_41","marker":"_marker_1t6rm_120"};
export { css, digest };
  